export const BLOGS_REQUEST_GET = "BLOGS_REQUEST_GET";
export const BLOGS_SUCCESS_GET = "BLOGS_SUCCESS_GET";
export const BLOGS_FAIL_GET = "BLOGS_FAIL_GET";
export const BLOGS_RESET_GET = "BLOGS_RESET_GET";

export const BLOGS_REQUEST_CREATE = "BLOGS_REQUEST_CREATE";
export const BLOGS_SUCCESS_CREATE = "BLOGS_SUCCESS_CREATE";
export const BLOGS_FAIL_CREATE = "BLOGS_FAIL_CREATE";
export const BLOGS_RESET_CREATE = "BLOGS_RESET_CREATE";

export const BLOGS_REQUEST_UPDATE = "BLOGS_REQUEST_UPDATE";
export const BLOGS_SUCCESS_UPDATE = "BLOGS_SUCCESS_UPDATE";
export const BLOGS_FAIL_UPDATE = "BLOGS_FAIL_UPDATE";
export const BLOGS_RESET_UPDATE = "BLOGS_RESET_UPDATE";

export const BLOGS_REQUEST_BYID = "BLOGS_REQUEST_BYID";
export const BLOGS_SUCCESS_BYID = "BLOGS_SUCCESS_BYID";
export const BLOGS_FAIL_BYID = "BLOGS_FAIL_BYID";
export const BLOGS_RESET_BYID = "BLOGS_RESET_BYID";

export const BLOGS_EXTRA_REQUEST = "BLOGS_EXTRA_REQUEST";
export const BLOGS_EXTRA_SUCCESS = "BLOGS_EXTRA_SUCCESS";
export const BLOGS_EXTRA_FAIL = "BLOGS_EXTRA_FAIL";
export const BLOGS_EXTRA_RESET = "BLOGS_EXTRA_RESET";

export const EXTRA_PUT_REQUEST = "EXTRA_PUT_REQUEST";
export const EXTRA_PUT_SUCCESS = "EXTRA_PUT_SUCCESS";
export const EXTRA_PUT_FAIL = "EXTRA_PUT_FAIL";
export const EXTRA_PUT_RESET = "EXTRA_PUT_RESET";

export const EXTRA_DELETE_REQUEST = "EXTRA_DELETE_REQUEST";
export const EXTRA_DELETE_SUCCESS = "EXTRA_DELETE_SUCCESS";
export const EXTRA_DELETE_FAIL = "EXTRA_DELETE_FAIL";
export const EXTRA_DELETE_RESET = "EXTRA_DELETE_RESET";
